package com.kinoshazam.screens.main.medium

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.kinoshazam.screens.main.FavoriteSyncStatus
import com.kinoshazam.screens.main.MediumBannerSkeletonCarousel
import com.kinoshazam.uiKit.components.carousel.CarouselNavButton
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.components.videoItem.MediumVideoItem
import com.kinoshazam.uiKit.components.videoItem.VideoState
import com.kinoshazam.uiKit.theme.Large
import com.kinoshazam.uiKit.theme.UiKitTheme
import features.videoDetails.data.model.FavoriteEntity
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.favorite_empty
import kinoshazam.resources.generated.resources.left
import kinoshazam.resources.generated.resources.movie
import kinoshazam.resources.generated.resources.right
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import presentation.screens.main.MainMVIAction
import presentation.screens.main.MainState

@Composable
fun ColumnScope.MediumFavoriteContent(
    state: MainState,
    onAction: (MainMVIAction) -> Unit,
) {
    Spacer(modifier = Modifier.Companion.weight(1f))

    val favorites = state.favoriteList
    if (favorites == null) {
        MediumBannerSkeletonCarousel()
    } else if (favorites.isEmpty()) {
        Box(
            modifier = Modifier.fillMaxSize(),
            contentAlignment = Alignment.Center,
        ) {
            TextLabel(
                state = TextLabelState(
                    text = stringResource(Res.string.favorite_empty),
                    color = UiKitTheme.colors.color_2,
                    textStyle = Large,
                )
            )
        }
    } else {
        FavoriteSyncStatus(state)
        LeftAlignedCarouselRowV3<FavoriteEntity>(
            items = state.favoriteList.orEmpty(),
            itemWidth = 164.dp,
            itemHeight = 280.dp,
            leftContent = { enabled, onClick ->
                CarouselNavButton(
                    painter = painterResource(Res.drawable.left),
                    enabled = enabled,
                    contentDescription = "Prev",
                    onClick = onClick,
                )
            },
            rightContent = { enabled, onClick ->
                CarouselNavButton(
                    painter = painterResource(Res.drawable.right),
                    enabled = enabled,
                    contentDescription = "Next",
                    onClick = onClick,
                )
            }
        ) { index, video, focused ->
            MediumVideoItem(
                state = VideoState(
                    id = video.videoId.toIntOrNull() ?: -1,
                    title = video.title.orEmpty(),
                    image = video.imageUrl,
                    placeHolder = painterResource(Res.drawable.movie),
                    placeHolderColor = UiKitTheme.colors.color_5,
                    onAction = { id ->
                        if (video.isTvShow) {
                            onAction(MainMVIAction.OnTvShowClicked(id))
                        } else {
                            onAction(MainMVIAction.OnDetailsClicked(id))
                        }
                    }
                ),
            )
        }
    }

    Spacer(modifier = Modifier.Companion.weight(1f))
}